<template>
  <div class="personalIndex">
    <!-- <h2>个人中心</h2> -->
    <div class="box">
      <!-- 个人信息数据 -->
      <div class="person_info">
        <div>
          <span>{{userInfo.realname.substring(0,1)}}</span>
          <span>{{userInfo.realname}}</span>
          <span>{{userInfo.mobile}}</span>
        </div>
        <div @click="logout_fun">退出登录</div>
      </div>
      <!--  -->
      <div class="edition cell" v-if="isApp"  @click="getVersion">
        <span>当前版本：{{version}}</span>
        <span>检查更新</span>
      </div>
      <div class="cell" @click="toForget">
        <span>重置密码</span>
        <span><i class="iconfont icon-next" style="font-size:0.26rem;"></i></span>
      </div>
      <div class="cell clearStorage" @click="updataRole">
        <span>清除缓存</span>
        <span></span>
      </div>
      <div class="cell priter">
        <span>打印机</span>
        <span>已连接
          <!-- <i class="iconfont icon-next" style="font-size:0.26rem;"></i> -->
        </span>
      </div>
    </div>
    <VersionUpdate ref="VersionUpdate"></VersionUpdate>
  </div>
</template>

<script>
import { setToken, removeToken } from "@/utils/auth";
import { getVersion } from "@/api/public";
import { logout } from "@/api/login";
import VersionUpdate from "@/components/VersionUpdate"
export default {
  name: 'personalIndex',
  components:{VersionUpdate},
  data(){
    return {
      userInfo:{},
      fistName:"",
      version:'',
      isApp:window.plus ? true : false
    }
  },
  created(){
    this.userInfo=JSON.parse(this.$Cookies.get('userInfo')) 
    var name=this.userInfo.realname
    this.fistName=name.substring(0,1)

    try {
      if(plus){
        this.version = plus.runtime.version
      }
    } catch (error) {
      
    }
  },
  mounted(){
  },
  methods:{
    // 退出登录
    logout_fun() {
      this.$dialog.confirm({
          title: "即将退出登录",
          content: "退出登录后内容将被清空！",
          confirmText:'退出',
          onConfirm:()=>{
             logout().then(res => {
            if (res.code == 200) {
              removeToken();
              this.$Cookies.remove("order_data");
              this.$Cookies.remove("order_total_num");
              this.$Cookies.remove("order_active_index");
              this.$Cookies.remove("rule");
              this.$router.push({
                path: "/"
              });
            }
          });
          }
        })
        
    },

    // 重置密码
    toForget(){
      this.$router.push({
        path:"/personal/forget",
        query:{
          mobile:this.userInfo.mobile
        }
      })
    },

    
    // 获取本地应用资源版本号
    getVersion(){
      var _this = this
      getVersion({type:3}).then(res=>{
        if(res.code == 200 ){
          if(res.data.version != this.version){
            this.$refs.VersionUpdate.showPop(res.data)
            // plus.nativeUI.alert("应用有新版本，是否立即下载更新？", function(event) {
            //   if(event.index == 0) {
            //     plus.runtime.openURL( res.data.url);
            //   }
            // },"版本更新","下载")
          }else{
            this.$toast.succeed("当前已是最新版本！")
          }
        }
      })
    },

    // 清除缓存
    updataRole(){
      // window.location.replace
      this.$toast.succeed("清除成功");
    },
  }
}
</script>

<style lang="less" scoped>
.personalIndex{
  position: relative;
  background-color: #e1e1e1;
  padding: 0.12rem;
  height: 100%;
  color: #333;
  font-size: 0.28rem;
  &>.box{
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 0.1rem;
    overflow: hidden;
    box-shadow: 0 0 0.04rem 0.1rem 0.04rem #fff;
    padding: 0.2rem;
    &>div{
      border-bottom: 0.01rem solid #f1f1f1;
    }
    .person_info{
      display: flex;
      justify-content: space-between;
      padding: 0.2rem 0;
      padding-bottom: 0.4rem;
      div:nth-of-type(1){
        display: flex;
        align-items: center;
        font-size: 0.32rem;
        line-height: 0.48rem;
        span{
          display: flex;
          justify-content: center;
          align-items: center;
        }
        span:nth-of-type(1){
          width: 0.8rem;
          height: 0.8rem;
          border-radius: 50%;
          background: #FF6633;
          color: #fff;
          margin-right: 0.4rem;
          font-size: 0.44rem;
          font-weight: 400;
        }
        span:nth-of-type(2){
          margin-right: 0.2rem;
        }
      }
      div:nth-of-type(2){
        width: 1.4rem;
        height: 0.6rem;
        line-height: 0.6rem;
        background-color: #31B158;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0.04rem;
        color: #fff;
      }

    }
    .cell{
      height: 0.86rem;
      line-height: 0.85rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.26rem;
    }
  }
}
</style>